module.exports = __webpack_public_path__ + "static/media/Happy1.cbc74672.svg";